/*
 * About: dos comportamientos pequenos.
 *
 *  1. <reda-cv>     Boton de abrir y cerrar todas las categorias a la vez.
 *                   Plegar una a una lo hace <details> por su cuenta.
 *  2. <reda-anclas> Desplazamiento suave a bio y CV, y marcado en negrita
 *                   del enlace de la seccion visible con IntersectionObserver.
 */

function redaPrefiereMenosMovimiento() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/* -------------------------------------------------------------------------
   1. CV
   ------------------------------------------------------------------------- */

if (!customElements.get('reda-cv')) {
  customElements.define(
    'reda-cv',
    class RedaCv extends HTMLElement {
      constructor() {
        super();

        this.boton = this.querySelector('[data-reda-todas]');
        this.categorias = Array.from(this.querySelectorAll('details'));

        this.alternarTodas = this.alternarTodas.bind(this);
        this.sincronizar = this.sincronizar.bind(this);
      }

      connectedCallback() {
        if (!this.boton || this.categorias.length === 0) return;

        this.boton.addEventListener('click', this.alternarTodas);

        // Si se pliega una a mano, el boton tiene que enterarse.
        this.categorias.forEach((categoria) => {
          categoria.addEventListener('toggle', this.sincronizar);
        });

        this.sincronizar();
      }

      todasAbiertas() {
        return this.categorias.every((categoria) => categoria.open);
      }

      alternarTodas() {
        const abrir = !this.todasAbiertas();
        this.categorias.forEach((categoria) => {
          categoria.open = abrir;
        });
        this.sincronizar();
      }

      sincronizar() {
        const abiertas = this.todasAbiertas();
        this.boton.setAttribute('aria-expanded', abiertas ? 'true' : 'false');
        this.boton.textContent = abiertas
          ? this.boton.dataset.cerrar
          : this.boton.dataset.abrir;
      }
    }
  );
}

/* -------------------------------------------------------------------------
   2. Anclas
   ------------------------------------------------------------------------- */

if (!customElements.get('reda-anclas')) {
  customElements.define(
    'reda-anclas',
    class RedaAnclas extends HTMLElement {
      constructor() {
        super();

        this.enlaces = Array.from(this.querySelectorAll('[data-reda-ancla]'));
        this.pares = [];
        this.observador = null;

        this.alPulsar = this.alPulsar.bind(this);
      }

      connectedCallback() {
        this.enlaces.forEach((enlace) => {
          const id = (enlace.getAttribute('href') || '').slice(1);
          const destino = id ? document.getElementById(id) : null;

          // Enlace sin destino: la seccion no esta en la pagina. Se esconde
          // en vez de dejar un enlace muerto.
          if (!destino) {
            const item = enlace.closest('li') || enlace;
            item.hidden = true;
            return;
          }

          this.pares.push({ enlace, destino });
          enlace.addEventListener('click', this.alPulsar);
        });

        if (this.pares.length === 0) return;

        this.marcar(this.pares[0].enlace);
        this.vigilar();
      }

      disconnectedCallback() {
        if (this.observador) this.observador.disconnect();
      }

      alPulsar(evento) {
        const par = this.pares.find((p) => p.enlace === evento.currentTarget);
        if (!par) return;

        evento.preventDefault();

        par.destino.scrollIntoView({
          behavior: redaPrefiereMenosMovimiento() ? 'auto' : 'smooth',
          block: 'start',
        });

        // El foco acompana al scroll, si no el teclado se queda arriba.
        par.destino.focus({ preventScroll: true });
        this.marcar(par.enlace);
      }

      vigilar() {
        if (!('IntersectionObserver' in window)) return;

        // El observer solo hace de disparador: quien decide es `actualizar`.
        // Reaccionar a la entrada que llega marcada como visible no vale,
        // porque el orden de las entradas no esta garantizado y al volver
        // arriba el enlace se quedaba pegado en la seccion anterior.
        this.observador = new IntersectionObserver(() => this.actualizar(), {
          rootMargin: '-25% 0px -70% 0px',
          threshold: 0,
        });

        this.pares.forEach((par) => this.observador.observe(par.destino));
      }

      // Activa la ultima seccion cuyo borde superior ya paso la franja alta
      // de la ventana. Arriba del todo siempre gana la primera.
      actualizar() {
        const limite = window.innerHeight * 0.3;
        let activo = this.pares[0];

        this.pares.forEach((par) => {
          if (par.destino.getBoundingClientRect().top <= limite) activo = par;
        });

        this.marcar(activo.enlace);
      }

      marcar(activo) {
        this.pares.forEach(({ enlace }) => {
          const esActivo = enlace === activo;
          enlace.classList.toggle('reda-anclas__enlace--activo', esActivo);
          if (esActivo) {
            enlace.setAttribute('aria-current', 'true');
          } else {
            enlace.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
